import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createBlock(_component_svg_icon, {
    width: _ctx.width,
    height: _ctx.height,
    iconColor: _ctx.iconColor,
    strokeWidth: "2.5"
  }, {
    default: _withCtx(() => _cache[0] || (_cache[0] = [
      _createElementVNode("polyline", { points: "6 9 12 15 18 9" }, null, -1)
    ])),
    _: 1,
    __: [0]
  }, 8, ["width", "height", "iconColor"]))
}